/* GASSISA
=========================================================================================
* Descripción: Actions del módulo de Pago de Comisiones por Venta
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 19/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddIcon from '@mui/icons-material/Add';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuComisionesActions({ onCalcularComisiones, handleClickRegresarMainDashboard, onNuevo, onGenerarReporte }) {
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    return (
        <Fragment>
            <Tooltip title={"Salir"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </Tooltip>
            {onNuevo && (
                <Tooltip title={"Nueva Consulta"}>
                    <IconButton onClick={() => executeWithProtection(onNuevo)} disabled={isProcessing}>
                        <AddIcon className="icon" /><p className="icon"> Nuevo</p>
                    </IconButton>
                </Tooltip>
            )}
            <Tooltip title={"Calcular Comisiones"}>
                <IconButton onClick={() => onCalcularComisiones && executeWithProtection(onCalcularComisiones)} disabled={isProcessing || !onCalcularComisiones}>
                    <CalculateIcon className="icon" /><p className="icon"> Calcular</p>
                </IconButton>
            </Tooltip>
            {onGenerarReporte && (
                <Tooltip title={"Generar Reporte PDF"}>
                    <IconButton onClick={() => executeWithProtection(onGenerarReporte)} disabled={isProcessing}>
                        <PictureAsPdfIcon className="icon" /><p className="icon"> PDF</p>
                    </IconButton>
                </Tooltip>
            )}
        </Fragment>
    );
}
